<template>
  <div>
    <Form
      :model="projectItem"
      ref="formValidate"
      :label-width="120"
      :rules="formValidate"
    >
      <FormItem label="项目名称：" prop="name">
        <Input v-model="projectItem.name" autocomplete="off"></Input>
      </FormItem>
      <FormItem label="使用资源：" prop="resourceList">
        <Select
          ref="rlist"
          v-model="projectItem.resourceList"
          filterable
          multiple
          @on-change="changeResource"
        >
          <Option
            v-for="item in resourceList"
            :value="item.id"
            :key="item.id"
            >{{ item.companyName }}</Option
          >
        </Select>
      </FormItem>
      <FormItem label="项目状态：" prop="status">
        <Select v-model="projectItem.status">
          <Option value="进行中">进行中</Option>
          <Option value="已完结">已完结</Option>
        </Select>
      </FormItem>
      <FormItem label="任务类别：" required>
        <tree-select
          :data="treeData"
          v-model="treeSelected"
          @on-select-change="handleTreeSelectClick"
        ></tree-select>
      </FormItem>
      <FormItem label="任务概述：" prop="describe">
        <Input
          type="textarea"
          v-model="projectItem.describe"
          autocomplete="off"
        ></Input>
      </FormItem>
      <FormItem label="合同单价：" prop="unitprice">
        <InputNumber
          v-model="projectItem.unitprice"
          autocomplete="off"
          controls-outside
        ></InputNumber>
      </FormItem>
      <FormItem label="数据总量：" prop="totalCount">
        <InputNumber
          v-model="projectItem.totalCount"
          autocomplete="off"
          controls-outside
        ></InputNumber>
      </FormItem>
      <FormItem label="合同总金额：" prop="amountOfMoney">
        <InputNumber
          v-model="projectItem.amountOfMoney"
          autocomplete="off"
          controls-outside
        ></InputNumber>
      </FormItem>
      <FormItem label="开始时间：" prop="startTime">
        <DatePicker
          type="date"
          placeholder="选择日期"
          v-model="projectItem.startTime"
          @on-change="getStartTime"
        ></DatePicker>
      </FormItem>
      <FormItem label="结束时间：" prop="endTime">
        <DatePicker
          type="date"
          placeholder="选择日期"
          v-model="projectItem.endTime"
          @on-change="getEndTime"
        ></DatePicker>
      </FormItem>
      <FormItem label="项目负责人评价：" prop="appraise">
        <Input
          type="textarea"
          v-model="projectItem.appraise"
          autocomplete="off"
        ></Input>
      </FormItem>
      <FormItem>
        <Button type="primary" long :loading="addLoading" @click="saveProject"
          >保存</Button
        >
      </FormItem>
    </Form>
  </div>
</template>
<script>
import resource from "@/api/resource.js";
import project from "@/api/project.js";
import treeSelect from "_c/tree-select";
export default {
  components: {
    treeSelect,
  },
  data() {
    return {
      treeSelected: [],
      addLoading: false,
      projectItem: {
        resourceList: [],
      },
      treeData: [],
      formValidate: {
        name: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
          {
            type: "string",
            max: 200,
            message: "名称不能超过200个字",
            trigger: "blur",
          },
        ],
        status: [
          {
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],

        describe: [
          {
            required: true,
            message: "请填写概述",
            trigger: "blur",
          },
          {
            type: "string",
            max: 2000,
            message: "名称不能超过2000个字",
            trigger: "blur",
          },
        ],
        unitprice: [
          {
            type: "number",
            required: true,
            message: "请填写单价",
            trigger: "blur",
          },
        ],
        totalCount: [
          {
            type: "number",
            required: true,
            message: "请填写数据总量",
            trigger: "blur",
          },
        ],
        amountOfMoney: [
          {
            type: "number",
            required: true,
            message: "请填写总金额",
            trigger: "blur",
          },
        ],
      },
      resourceList: [],
    };
  },
  methods: {
    getData() {
      return this.projectItem;
    },
    getProjectTypeList() {
      project.getProjectTypeList().then((res) => {
        this.projectTypeList = res.data;
        this.treeData = this.projectTypeList
          .filter((x) => !x.parentId)
          .map(this.MapChild);
        console.log(this.treeData);
      });
    },
    MapChild(x) {
      x.children = [];
      x.children = this.projectTypeList
        .filter((y) => y.parentId == x.id)
        .map(this.MapChild);
      x.title = x.name;

      return x;
    },
    reset() {
      this.projectItem = { resourceList: [] };
      this.treeSelected = [];
      this.$refs.formValidate.resetFields();
    },
    setData(data) {
      this.projectItem = JSON.parse(JSON.stringify(data));

      let pr = this.projectItem.projectResource.map((x) => {
        return x.resourceId;
      });

      this.treeSelected = [this.projectItem.projectTypeId];

      this.projectItem.resourceList = pr;

      console.log(this.projectItem);
    },
    getStartTime(e) {
      this.projectItem.startTime = e;
    },
    getEndTime(e) {
      this.projectItem.endTime = e;
    },
    getResourceList() {
      let _this = this;
      resource.allResourceList().then((res) => {
        _this.resourceList = res.data;
      });
    },
    saveProject() {
      let _this = this;

      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          var data = this.projectItem;
          //   for (let i in data.resourceList) {
          //     data.resourceList[i] = {
          //       id: data.resourceList[i],
          //     };
          //   }
          //console.log(data);
          _this.addLoading = true;
          if (data.id) {
            project
              .updateProject(data)
              .then((res) => {
                _this.$Message.success("保存成功");
                _this.addLoading = false;
                _this.$emit("saved");
              })
              .catch((err) => {
                _this.addLoading = false;
                _this.$Message.error(
                  err?.response?.data?.message ||
                    JSON.stringify(err?.response?.data)
                );
              });
          } else {
            project
              .addProject(data)
              .then((res) => {
                _this.$Message.success("保存成功");
                _this.addLoading = false;
                _this.$emit("saved");
              })
              .catch((err) => {
                _this.addLoading = false;
                _this.$Message.error(
                  err?.response?.data?.message ||
                    JSON.stringify(err?.response?.data)
                );
              });
          }
        }
      });
    },
    handleTreeSelectClick(selectArray, item) {
      this.treeSelected = selectArray.map((x) => {
        return x.id;
      });
      this.projectItem.ProjectTypeId = this.treeSelected[0];
    },
    changeResource(item) {
      console.log(item);
    },
  },
  mounted() {
    this.getResourceList();
    this.getProjectTypeList();
  },
};
</script>
